// Service für Nutzer-API Calls
import { apiClient } from './api';
import { Nutzer, NutzerCreateRequest, NutzerUpdateRequest, NutzerPageResponse } from '../types/nutzer';

export class NutzerService {
  private static readonly ENDPOINT = '/nutzer';

  // Alle Nutzer abrufen (mit Pagination)
  static async getAlleNutzer(
    page: number = 0,
    size: number = 20,
    sortBy: string = 'id',
    sortDir: string = 'asc'
  ): Promise<NutzerPageResponse> {
    const response = await apiClient.get<NutzerPageResponse>(this.ENDPOINT, {
      params: { page, size, sortBy, sortDir }
    });
    return response.data;
  }

  // Einzelnen Nutzer abrufen
  static async getNutzerById(id: number): Promise<Nutzer> {
    const response = await apiClient.get<Nutzer>(`${this.ENDPOINT}/${id}`);
    return response.data;
  }

  // Neuen Nutzer erstellen
  static async createNutzer(nutzer: NutzerCreateRequest): Promise<Nutzer> {
    const response = await apiClient.post<Nutzer>(this.ENDPOINT, nutzer);
    return response.data;
  }

  // Nutzer aktualisieren
  static async updateNutzer(id: number, nutzer: NutzerUpdateRequest): Promise<Nutzer> {
    const response = await apiClient.put<Nutzer>(`${this.ENDPOINT}/${id}`, nutzer);
    return response.data;
  }

  // Nutzer löschen
  static async deleteNutzer(id: number): Promise<void> {
    await apiClient.delete(`${this.ENDPOINT}/${id}`);
  }

  // Nutzer nach Kunde filtern
  static async getNutzerByKunde(kundeId: number): Promise<Nutzer[]> {
    const response = await apiClient.get<Nutzer[]>(`${this.ENDPOINT}/kunde/${kundeId}`);
    return response.data;
  }

  // Nutzer nach Benutzername suchen
  static async searchNutzerByBenutzername(username: string): Promise<Nutzer[]> {
    const response = await apiClient.get<Nutzer[]>(`${this.ENDPOINT}/search`, {
      params: { username }
    });
    return response.data;
  }
}
